import { ospThemes } from "@ospweb/sdk-ui";
import { SignalLevel } from "../DetailsCommon/Forecast/constants";

// 信号等级配置
export const SIGNAL_LEVELS = [
  {
    key: SignalLevel.STRONG_SELL,
    label: "Strong Sell",
    bgColor: ospThemes.colors.background_accent2_overlay20,
    activeColor: ospThemes.colors.background_accent2_overlay100,
    activeBgColor: ospThemes.colors.background_accent2_overlay100,
    linearBGClassName:
      "bg-gradient-to-t from-[#FF4347]/10 to-[#FF4347]/0 to-96%",
  },
  {
    key: SignalLevel.SELL,
    label: "Sell",
    bgColor: ospThemes.colors.background_accent3_overlay20,
    activeColor: ospThemes.colors.background_accent3_overlay100,
    activeBgColor: ospThemes.colors.background_accent3_overlay100,
    linearBGClassName:
      "bg-gradient-to-t from-[#FD8016]/10 to-[#FD8016]/0 to-96%",
  },
  {
    key: SignalLevel.NEUTRAL,
    label: "Neutral",
    bgColor: ospThemes.colors.background_auralv3_overlay20,
    activeColor: ospThemes.colors.background_auralv3_overlay100,
    activeBgColor: ospThemes.colors.background_auralv3_overlay100,
    linearBGClassName:
      "bg-gradient-to-t from-[#FFFFB0]/10 to-[#FFFFB0]/0 to-96%",
  },
  {
    key: SignalLevel.BUY,
    label: "Buy",
    bgColor: ospThemes.colors.background_accent1_overlay20,
    activeColor: ospThemes.colors.background_accent1_overlay100,
    activeBgColor: ospThemes.colors.background_accent1_overlay100,
    linearBGClassName:
      "bg-gradient-to-t from-[#02D79B]/10 to-[#02D79B]/0 to-96%",
  },
  {
    key: SignalLevel.STRONG_BUY,
    label: "Strong Buy",
    bgColor: ospThemes.colors.background_accent1_overlay20,
    activeColor: ospThemes.colors.background_accent1_overlay100,
    activeBgColor: ospThemes.colors.background_accent1_overlay100,
    linearBGClassName:
      "bg-gradient-to-t from-[#02D79B]/10 to-[#02D79B]/0 to-96%",
  },
] as const;
